/* Glambe playful effects: sparkle trail, floating glitter, confetti, tilt, scroll bar */
(function () {
  var cfg = document.getElementById('gbfx-cfg'); if (!cfg || window.__gbfx) return; window.__gbfx = 1;
  var o = cfg.dataset, reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var SYM = ['✦', '♡', '❀', '★', '✧'], COL = ['#9A83D2', '#F5A3D0', '#CDBDEB', '#C9A6FF', '#FFFFFF'];
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  /* scroll bar */
  if (o.bar === '1') {
    var b = document.createElement('div'); b.className = 'gbfx-bar'; document.body.appendChild(b);
    var t = false; function u() { t = false; var h = document.documentElement.scrollHeight - innerHeight; b.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')'; }
    addEventListener('scroll', function () { if (!t) { t = true; requestAnimationFrame(u); } }, { passive: true }); u();
  }
  /* Glow Up speed dial: the corner sticker opens a quick menu */
  var dial = document.querySelector('[data-gbfx-dial]');
  if (dial) {
    var sb = dial.querySelector('.gbfx-sticker'), sl = sb.querySelector('span'), lab = sl.textContent;
    var setOpen = function (v) { dial.classList.toggle('is-open', v); sb.setAttribute('aria-expanded', v ? 'true' : 'false'); sl.innerHTML = v ? '<b aria-hidden="true">✕</b>' : ''; if (!v) sl.textContent = lab; };
    sb.addEventListener('click', function (e) { e.stopPropagation(); setOpen(!dial.classList.contains('is-open')); });
    document.addEventListener('click', function (e) { if (dial.classList.contains('is-open') && !dial.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dial.classList.contains('is-open')) { setOpen(false); sb.focus(); } });
    [].forEach.call(dial.querySelectorAll('.gbfx-menu a'), function (a) {
      a.addEventListener('click', function (e) {
        var h = a.getAttribute('href') || '', i = h.indexOf('#'); setOpen(false);
        if (i >= 0) { var path = h.slice(0, i), id = h.slice(i + 1), same = !path || path === '/' && location.pathname === '/' || path === location.pathname; var t = id && same ? document.getElementById(id) : null; if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } }
      });
    });
  }
    /* Mobile reviews: one card at a time, then the rest keep moving by themselves */
  (function () {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    var rm0 = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    [].forEach.call(document.querySelectorAll('[data-gbr]'), function (vp) {
      if (vp.__gbrAuto) return; vp.__gbrAuto = 1;
      var timer = 0, inView = false, hold = 0;
      function cards() { return vp.querySelectorAll('.gbr__g:not([aria-hidden]) .gbr__c'); }
      function cur(cs) { var c = vp.scrollLeft + vp.clientWidth / 2, b = 0, d = 1e9; for (var i = 0; i < cs.length; i++) { var m = Math.abs(cs[i].offsetLeft + cs[i].offsetWidth / 2 - c); if (m < d) { d = m; b = i; } } return b; }
      function step() {
        if (!mq.matches || !inView || rm0 || document.hidden || Date.now() < hold) return;
        var cs = cards(); if (cs.length < 2) return;
        var i = cur(cs) + 1; if (i >= cs.length) i = 0;
        vp.scrollTo({ left: cs[i].offsetLeft + cs[i].offsetWidth / 2 - vp.clientWidth / 2, behavior: 'smooth' });
      }
      function pause() { hold = Date.now() + 6000; }
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { vp.addEventListener(ev, pause, { passive: true }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: .4 }).observe(vp);
      } else { inView = true; }
      timer = setInterval(step, 3400);
    });
  })();
  if (reduce) return;
  /* burst */
  function burst(x, y, n, big) {
    for (var i = 0; i < n; i++) {
      var s = document.createElement('span'); s.className = 'gbfx-pop'; s.textContent = pick(SYM);
      s.style.color = pick(COL); s.style.fontSize = rnd(big ? 14 : 10, big ? 30 : 20) + 'px'; s.style.textShadow = '0 0 8px rgba(245,163,208,.8)';
      document.body.appendChild(s);
      var a = rnd(0, Math.PI * 2), d = rnd(big ? 70 : 40, big ? 190 : 100), dx = Math.cos(a) * d, dy = Math.sin(a) * d - (big ? 60 : 20);
      var an = s.animate([{ transform: 'translate(' + x + 'px,' + y + 'px) scale(.3) rotate(0)', opacity: 1 }, { transform: 'translate(' + (x + dx) + 'px,' + (y + dy + 80) + 'px) scale(1.1) rotate(' + rnd(-300, 300) + 'deg)', opacity: 0 }], { duration: rnd(700, 1300), easing: 'cubic-bezier(.2,.7,.3,1)' });
      an.onfinish = (function (el) { return function () { el.remove(); }; })(s);
    }
  }
  window.gbfxBurst = burst;
  /* cursor sparkle trail */
  if (o.trail === '1' && fine) {
    var last = 0;
    addEventListener('mousemove', function (e) {
      var now = performance.now(); if (now - last < 45) return; last = now;
      var s = document.createElement('span'); s.className = 'gbfx-spark'; s.textContent = pick(SYM); s.style.color = pick(COL); s.style.fontSize = rnd(9, 17) + 'px';
      document.body.appendChild(s);
      var an = s.animate([{ transform: 'translate(' + e.clientX + 'px,' + e.clientY + 'px) scale(1) rotate(0)', opacity: .95 }, { transform: 'translate(' + (e.clientX + rnd(-18, 18)) + 'px,' + (e.clientY + rnd(18, 46)) + 'px) scale(.2) rotate(' + rnd(-180, 180) + 'deg)', opacity: 0 }], { duration: 750, easing: 'ease-out' });
      an.onfinish = function () { s.remove(); };
    }, { passive: true });
  }
  /* floating glitter */
  if (+o.float > 0) {
    var f = document.createElement('div'); f.className = 'gbfx-float'; f.setAttribute('aria-hidden', 'true');
    var n = innerWidth < 700 ? Math.ceil(+o.float / 2) : +o.float;
    for (var i = 0; i < n; i++) { var p = document.createElement('i'); p.textContent = pick(SYM); p.style.left = rnd(0, 100) + '%'; p.style.fontSize = rnd(10, 24) + 'px'; p.style.color = pick(COL); p.style.animationDuration = rnd(11, 24) + 's'; p.style.animationDelay = (-rnd(0, 20)) + 's'; p.style.setProperty('--dx', rnd(-60, 60) + 'px'); f.appendChild(p); }
    document.body.appendChild(f);
  }
  /* confetti on key buttons and choices */
  if (o.confetti === '1') {
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('.gbp__atc,.gbp-sticky button,.gbb__btn,.gbp__tier,.gbb__item,.gb-btn');
      if (!el) return; var r = el.getBoundingClientRect(), big = !!el.closest('.gbp__atc,.gbb__btn,.gbp-sticky,.gb-btn');
      burst(e.clientX || r.left + r.width / 2, e.clientY || r.top + r.height / 2, big ? 22 : 12, big);
    });
  }
  /* 3D tilt + glow on cards */
  if (o.tilt === '1' && fine) {
    var sel = '.gbk__c,.gba__c,.gbb__item,.gbb__sum,.gbo__step,.gbv__c.is-active';
    document.addEventListener('mousemove', function (e) {
      var c = e.target.closest && e.target.closest(sel); if (!c) return; var r = c.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      c.classList.add('gbfx-tilt'); c.style.transform = 'perspective(900px) rotateX(' + (-y * 8).toFixed(2) + 'deg) rotateY(' + (x * 10).toFixed(2) + 'deg) translateY(-6px)';
    }, { passive: true });
    document.addEventListener('mouseout', function (e) { var c = e.target.closest && e.target.closest(sel); if (c && !c.contains(e.relatedTarget)) c.style.transform = ''; });
  }
  /* shimmer headings + wiggle main button */
  if (o.shine === '1') { [].forEach.call(document.querySelectorAll('.gb-h2,.gbp__title'), function (h) { h.classList.add('gbfx-shine'); }); }
  if (o.wiggle === '1') { var a = document.querySelector('.gbp__atc'); if (a) { setInterval(function () { a.classList.remove('gbfx-wiggle'); void a.offsetWidth; a.classList.add('gbfx-wiggle'); }, 6000); } }
})();